import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { GlobalMessageService } from '@spartacus/core';
import {
  ProductListComponent,
  ProductListComponentService,
  PageLayoutService,
  ViewConfig,
} from '@spartacus/storefront';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-service-tool-tab',
  templateUrl: './service-tool-tab.component.html',
  styleUrls: ['./service-tool-tab.component.scss'],
  standalone: false
})
export class ServiceToolTabComponent extends ProductListComponent {
  @Input() product;
  productCopy: any;
  isMobile: boolean;
  showSearch: boolean[] = [false];
  showToggleResults: boolean[] = [false];
  inputFormControl = new FormControl('');
  sortControl = new FormControl('code_asc');
  filteredProduct: any;
  initialKbEcomDocuments: any;
  test: any;
  currentArray: any;
  sortedArray: any;
  initialCounter: number = 0;
  private destroy$ = new Subject<void>();
  constructor(
    public breakpointObserver: BreakpointObserver,
    productListComponentService: ProductListComponentService,
    pageLayoutService: PageLayoutService,
    globalMessageService: GlobalMessageService,
    scrollConfig: ViewConfig
  ) {
    super(
      pageLayoutService,
      productListComponentService,
      globalMessageService,
      scrollConfig
    );

    this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.isMobile = result.matches;
        if (this.isMobile) {
          this.setViewMode(this.ViewModes.Grid);
        } else {
          this.setViewMode(this.ViewModes.List);
        }
      });
  }

  InputValueChanged(el, currentArray, ArrayName) {
    const newValue = (el.target as HTMLSelectElement).value;
    this.search(newValue, currentArray, ArrayName);
  }
  sortControlValueChanged(el, currentArray, ArrayName) {
    const newValue = (el.target as HTMLSelectElement).value;
    this.sortBy(newValue, currentArray, ArrayName);
  }

  sortBy(option: string, currentArray, ArrayName) {
    const key = ArrayName;
    const sortedArray = currentArray.slice();
    const [property, order] = option.split('_');
    this.productCopy[key] = sortedArray.sort((a, b) => {
      const aValue = a.target[property];
      const bValue = b.target[property];
      if (aValue < bValue) {
        return order === 'asc' ? -1 : 1;
      } else if (aValue > bValue) {
        return order === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  search(value: string, responseObject: any[], ArrayName: string) {
    this.currentArray = this.product.serviceTools[ArrayName];
    if (value.trim() === '') {
      this.productCopy[ArrayName] = this.currentArray;
    } else {
      // Perform filtering based on search term
      this.productCopy[ArrayName] = this.currentArray.filter((item) => {
        return Object.values(item.target).some((val: any) =>
          val.toString().toLowerCase().includes(value.toLowerCase())
        );
      });
    }
  }
  ngOnChanges() {
    this.productCopy = JSON.parse(JSON.stringify(this.product.serviceTools));
  }
  getObjectKeys(obj: any) {
    return Object.keys(obj);
  }
  isArray(value: any, index) {
    if (Array.isArray(value) && value.length > 0 && this.initialCounter == 0) {
      this.showToggleResults[index] = true;
      this.initialCounter = 1;
    }
    return Array.isArray(value);
  }
  override ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
